<template>
  <template v-if="showFullLayout">
    <TheHeader />

    <RouterView v-if="$route.name === 'customers'" class="py-5 md:p-10" />

    <main v-else class="flex" :class="{'citizen-m bg-white': isCitizenM }">
      <TheAside />

      <RouterView class="router-view py-5 md:p-5 lg:p-10" />
    </main>
  </template>
  <RouterView v-else :class="{'citizen-m': isCitizenM }" />

  <NewVersionNotification v-if="isNewVersionAvailable" />
</template>

<script>
import TheHeader from '@/components/header/TheHeader'
import TheAside from '@/components/aside/TheAside'
import { CUSTOMER_IDS } from '@/constants'
import NewVersionNotification from '@/components/page-elements/NewVersionNotification'

export default {
  components: { NewVersionNotification, TheAside, TheHeader },
  page: {
    titleTemplate: (titleChunk) => titleChunk ? `${titleChunk} | Coretix` : 'Coretix'
  },
  computed: {
    showFullLayout () {
      return this.$route.name !== 'login' && this.$store.getters['auth/loggedIn'] && this.$store.getters['auth/privileges'].length
    },
    isCitizenM () {
      return this.$store.getters['customers/customer'] && this.$store.getters['customers/customer'].ID === CUSTOMER_IDS.CITIZENM
    },
    isNewVersionAvailable () {
      return this.$store.getters['app/isNewVersionAvailable']
    }
  }
}
</script>
